import React from 'react';

// Common fallback icon
import QuestionCircleOutlined from '@ant-design/icons/QuestionCircleOutlined';

// Commonly used icons in the dashboard
import DashboardOutlined from '@ant-design/icons/DashboardOutlined';
import CalendarOutlined from '@ant-design/icons/CalendarOutlined';
import TeamOutlined from '@ant-design/icons/TeamOutlined';
import UserOutlined from '@ant-design/icons/UserOutlined';
import SettingOutlined from '@ant-design/icons/SettingOutlined';
import MedicineBoxOutlined from '@ant-design/icons/MedicineBoxOutlined';
import FileDoneOutlined from '@ant-design/icons/FileDoneOutlined';
import SafetyCertificateOutlined from '@ant-design/icons/SafetyCertificateOutlined';
import AppstoreOutlined from '@ant-design/icons/AppstoreOutlined';
import PlusOutlined from '@ant-design/icons/PlusOutlined';
import OrderedListOutlined from '@ant-design/icons/OrderedListOutlined';
import ClockCircleOutlined from '@ant-design/icons/ClockCircleOutlined';
import CoffeeOutlined from '@ant-design/icons/CoffeeOutlined';
import DollarOutlined from '@ant-design/icons/DollarOutlined';
import InboxOutlined from '@ant-design/icons/InboxOutlined';
import BarChartOutlined from '@ant-design/icons/BarChartOutlined';
import IdcardOutlined from '@ant-design/icons/IdcardOutlined';
import FileProtectOutlined from '@ant-design/icons/FileProtectOutlined';
import TransactionOutlined from '@ant-design/icons/TransactionOutlined';
import MinusCircleOutlined from '@ant-design/icons/MinusCircleOutlined';
import ShopOutlined from '@ant-design/icons/ShopOutlined';
import ShoppingCartOutlined from '@ant-design/icons/ShoppingCartOutlined';
import MessageOutlined from '@ant-design/icons/MessageOutlined';
import WhatsAppOutlined from '@ant-design/icons/WhatsAppOutlined';
import BellOutlined from '@ant-design/icons/BellOutlined';
import SolutionOutlined from '@ant-design/icons/SolutionOutlined';
import BankOutlined from '@ant-design/icons/BankOutlined';
import ApiOutlined from '@ant-design/icons/ApiOutlined';
import ScheduleOutlined from '@ant-design/icons/ScheduleOutlined';
import ApartmentOutlined from '@ant-design/icons/ApartmentOutlined';
import ToolOutlined from '@ant-design/icons/ToolOutlined';
import ExperimentOutlined from '@ant-design/icons/ExperimentOutlined';
import AuditOutlined from '@ant-design/icons/AuditOutlined';

const iconMap = {
  DashboardOutlined,
  CalendarOutlined,
  TeamOutlined,
  UserOutlined,
  SettingOutlined,
  MedicineBoxOutlined,
  FileDoneOutlined,
  SafetyCertificateOutlined,
  AppstoreOutlined,
  PlusOutlined,
  OrderedListOutlined,
  ClockCircleOutlined,
  CoffeeOutlined,
  DollarOutlined,
  InboxOutlined,
  BarChartOutlined,
  IdcardOutlined,
  FileProtectOutlined,
  TransactionOutlined,
  MinusCircleOutlined,
  ShopOutlined,
  ShoppingCartOutlined,
  MessageOutlined,
  WhatsAppOutlined,
  BellOutlined,
  SolutionOutlined,
  BankOutlined,
  ApiOutlined,
  ScheduleOutlined,
  ApartmentOutlined,
  ToolOutlined,
  ExperimentOutlined,
  AuditOutlined
};

/**
 * Maps a string icon name to an Ant Design React icon component.
 * @param {string} iconName - The name of the icon (e.g., 'DashboardOutlined')
 * @returns {React.ElementType} The React icon component or a fallback icon.
 */
export const getIconComponent = (iconName) => {
  if (!iconName) return QuestionCircleOutlined;
  
  const Component = iconMap[iconName];
  if (Component) return Component;
  
  console.warn(`Icon '${iconName}' not found in iconMapper. Using fallback.`);
  return QuestionCircleOutlined;
};

export default getIconComponent;
